/**
 * @Module: User Preferences Types
 * @Status: Ready
 * @Summary: Cooking preferences that inform recipe generation and meal planning
 */

export interface UserPreferences {
  dietaryRestrictions: string[];
  cookingSkillLevel: 'beginner' | 'intermediate' | 'advanced';
  favoriteCuisines: string[];
  maxPrepTimeMinutes: number;
  householdSize: number;
  weeklyGoal: number;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  dietaryRestrictions: [],
  cookingSkillLevel: 'intermediate',
  favoriteCuisines: [],
  maxPrepTimeMinutes: 60,
  householdSize: 2,
  weeklyGoal: 3,
};

export const CUISINE_OPTIONS = [
  'Italian', 'Mexican', 'Chinese', 'Japanese', 'Indian',
  'American', 'Mediterranean', 'Thai', 'French', 'Korean',
  'Ethiopian', 'Greek', 'Vietnamese',
];

export const DIETARY_OPTIONS = [
  { label: 'Vegetarian', value: 'vegetarian' },
  { label: 'Vegan', value: 'vegan' },
  { label: 'Gluten-Free', value: 'gluten_free' },
  { label: 'Dairy-Free', value: 'dairy_free' },
  { label: 'Nut-Free', value: 'nut_free' },
  { label: 'Low-Carb', value: 'low_carb' },
  { label: 'Keto', value: 'keto' },
  { label: 'Halal', value: 'halal' },
  { label: 'Kosher', value: 'kosher' },
];
